module.exports = __webpack_public_path__ + "static/media/1POLICY47.2394d0df.jpg";